export const all_privileges = [1, 2, 3, 4]
export const admin_privileges = [1]
export const petugas_privileges = [4]
export const opd_privileges = [3]
export const perusahaan_privileges = [2]
export const my_projects_privileges = [2]
export const all_projects = [1, 2, 4]